<template>
  <counter
    :initial-value="initial"
    :min="min"
    :max="max"
    :step="step"
    @change="onChangeHandler"
    :name="name"
    :non-valid-input-message="nonValidInputMessage"
    :rounding-message="roundingMessage"
    :graduated-prices="graduatedPrices"
    ref="quantity"
    :current-predefined-quantity-index="10"
  />
</template>

<script>
  import Counter from '../counter/counter.vue';
  import cartService from '../../services/cart/cart.js';

  export default {
    components: {
      Counter
    },
    props: {
      min: {
        type: Number,
        default: 0
      },
      initial: Number,
      max: {
        type: Number,
        default: Number.MAX_VALUE
      },
      step: Number,
      changeUrl: String,
      positionId: String,
      itemId: String,
      name: String,
      roundingMessage: {
        type: String,
        default: ""
      },
      graduatedPrices: {
        type: Boolean,
        default: false
      },
      nonValidInputMessage: {
        type: String,
        default: ""
      }
    },
    data() {
      return {};
    },
    methods: {
      onChangeHandler(newValue) {
        if (newValue !== this.initial) {
          cartService()
            .changeQuantity(this.collectFormData(newValue))
            .then((data) => {
              if (data) {
                this.$store.dispatch('cartPage/updateCart', data);
              }
            });
        }
      },
      collectFormData(newValue) {
        let data = {};

        data.entryId = this.positionId;
        data.itemId = this.itemId;
        data.newItemId = this.itemId;
        data[this.name] = newValue;

        return data;
      }
    }
  };

</script>
